import * as React from "react";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import {
    DrawdownType,
    DrawdownType as DrawdownTypeEnum,
} from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionProtectionDetails } from "../../../../../../../Wrap/Models/Models/Customer/PensionProtection/PensionProtectionDetails";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DrawdownTypeOptionsMap } from "./Resource/Contents";

interface IDrawdownTypeProps extends IProcessComponentProps {
    pensionProtection: PensionProtectionDetails;
    originType: DrawdownType;
    isImmediateTaxFreeLumpSum: boolean;
}

interface IDrawdownTypeState {
    showDetail: boolean;
}

export class DrawdownTypeOption extends ProcessComponent<IDrawdownTypeProps, IDrawdownTypeState> {
    constructor(props: any) {
        super(props);
        this.state = { showDetail: false };
    }

    private getDrawdownTypeOptions(): DrawdownTypeEnum[] {
        const { pensionProtection, isImmediateTaxFreeLumpSum } = this.props;
        const options = [DrawdownTypeEnum.Flexible];
        if (
            !pensionProtection?.PensionPrimaryProtectionDetails?.PclsEntitlement &&
            !pensionProtection?.PensionSchemeSpecificProtectionDetails?.ProtectedRetirementAge &&
            !pensionProtection?.PensionSchemeSpecificProtectionDetails?.PclsEntitlement &&
            !isImmediateTaxFreeLumpSum
        ) {
            options.push(DrawdownTypeEnum.Regular);
        }
        return options;
    }

    public render(): JSX.Element {
        const { data, onChange, originType } = this.props;

        return (
            <>
                <SelectEditor
                    placeholder={"Please select"}
                    cssWrapper="control-size-430"
                    getText={(v) => {
                        return DrawdownTypeOptionsMap[v];
                    }}
                    label="Drawdown type"
                    options={this.getDrawdownTypeOptions()}
                    onChange={(v) => {
                        const originIsRegular = originType == DrawdownType.Regular;
                        const currIsRegular = v == DrawdownType.Regular;
                        const hasChanged = (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
                        onChange({ DrawdownType: v, ChangeInstructionType: hasChanged });
                    }}
                    selected={data?.DrawdownType}
                    required="Please select a drawdown type"
                />
                <hr className="mb-20" />
            </>
        );
    }
}
